// eslint-disable-next-line import/no-unresolved
const instoreBase = require('storepickup-base/checkout/instore');
const utils = require('../utils');
const clickCollect = require('./clickCollect');
const deliveryPoints = require('./deliveryPoints');
const shippingUtils = require('./shippingUtils');

/**
 * Show Address Shipping
 */
function showAddressShipping(shippingForm) {
    // hide address panel
    // hide address panel
    shippingForm.find('.shipment-selector-block, .shipping-address-block').removeClass('d-none');

    const toggleButton = $('.toggle-switch');
    if (toggleButton.hasClass('active')) {
        shippingForm.find('.gift-message-block').removeClass('d-none');
    }
}

/**
 * Hide store finder and restore address form
 * @param {Object} shippingForm - DOM element with current form
 * @param {Object} data - data containing customer and order objects
 */
function hideStoreFinder(shippingForm, data) {
    if (data.order.usingMultiShipping) {
        $('body').trigger('instore:hideMultiShipStoreFinder', {
            form: shippingForm,
            customer: data.customer,
            order: data.order,
        });
    } else {
        $('body').trigger('instore:hideSingleShipStoreFinder', {
            form: shippingForm,
            customer: data.customer,
            order: data.order,
        });
    }

    shippingForm.find('.pickup-in-store').addClass('d-none');
    shippingForm.find('.gift-message-block').removeClass('d-none');
    const pickupInStoreStoreResultSelected = $('#pickup-in-store-store-result-selected');
    if (pickupInStoreStoreResultSelected.length) {
        pickupInStoreStoreResultSelected.remove();
    }

    shippingForm.find('input[name="storeId"]').remove();
}

/**
 * Handles the initial state of single shipping on page load
 */
function handleInitialSingleship() {
    const pickupSelected = $(':checked', '.shipping-method-list').data('pickup');
    const clickcollectSelected = $(':checked', '.shipping-method-list').data('clickcollect');
    const deliveryPointSelected = $(':checked', '.shipping-method-list').data('deliverypoint');
    const storeSelected = $('.store-details').length;
    const shippingForm = $('.single-shipping .shipping-form');
    const storeID = storeSelected ? $('.store-details').data('store-id') : null;

    if (pickupSelected && !storeSelected) {
        shippingUtils.hideAddressShipping(shippingForm);
        shippingUtils.showStoreFinder(shippingForm);
    } else if (pickupSelected && storeSelected) {
        shippingForm
            .find('.pickup-in-store')
            .removeClass('d-none')
            .append(`<input type="hidden" name="storeId" value="${storeID}" />`);

        shippingUtils.hideAddressShipping(shippingForm);
        shippingForm.find('.clickcollect-in-store').addClass('d-none');
    } else if (clickcollectSelected && !storeSelected) {
        shippingUtils.hideAddressShipping(shippingForm);
        clickCollect.showClickCollectFinder(shippingForm);
    } else if (clickcollectSelected && storeSelected) {
        shippingForm
            .find('.clickcollect-in-store')
            .removeClass('d-none')
            .append(`<input type="hidden" name="storeId" value="${storeID}" />`);
        shippingUtils.hideAddressShipping(shippingForm);
        shippingForm.find('.pickup-in-store').addClass('d-none');
        clickCollect.showClickCollectFinder(shippingForm);
    } else if (deliveryPointSelected) {
        shippingUtils.hideAddressShipping(shippingForm);
        shippingForm.find('.pickup-in-store').addClass('d-none');
        deliveryPoints.showDeliveryPointFinder(shippingForm);
    }
}

/**
 * Handles the initial state of multi-shipping on page load
 */
function handleInitialMultiship() {
    $(':checked', '.multi-shipping .shipping-method-list').each(() => {
        const pickupSelected = $(this).data('pickup');
        const shippingForm = $(this).closest('form');
        const store = shippingForm.find('.store-details');
        const storeSelected = store.length;
        const storeID = storeSelected ? store.data('store-id') : null;

        if (pickupSelected && !storeSelected) {
            shippingUtils.showStoreFinder(shippingForm);
        } else if (pickupSelected && storeSelected) {
            shippingForm
                .find('.pickup-in-store')
                .removeClass('d-none')
                .append(`<input type="hidden" name="storeId" value="${storeID}" />`);
        } else {
            shippingForm.find('.pickup-in-store').addClass('d-none');
            shippingForm.find('.shipping-address-block').removeClass('d-none');
        }
    });
}

module.exports = {
    watchForInStoreShipping() {
        $('body').on('checkout:updateCheckoutView', (e, data) => {
            const multiShipFlag = data.order.usingMultiShipping;
            if (!data.urlParams || !data.urlParams.shipmentUUID) {
                data.order.shipping.forEach((shipment) => {
                    const form = $(
                        `.shipping-form input[name="shipmentUUID"][value="${shipment.UUID}"]`,
                    ).closest('form');

                    form.find('.pickup-in-store').data('url', shipment.pickupInstoreUrl);

                    $('#pickup-in-store-store-result').hide();

                    if (
                        shipment.selectedShippingMethod
                        && shipment.selectedShippingMethod.storePickupEnabled
                    ) {
                        shippingUtils.hideAddressShipping(form);
                        shippingUtils.showStoreFinder(form, multiShipFlag);
                    } else {
                        hideStoreFinder(form, data);
                    }

                    if (
                        shipment.selectedShippingMethod
                        && shipment.selectedShippingMethod.clickCollect
                    ) {
                        shippingUtils.hideAddressShipping(form);
                        clickCollect.showClickCollectFinder(form);
                    } else {
                        clickCollect.hideClickCollectFinder(form, data);
                    }

                    if (
                        shipment.selectedShippingMethod
                        && shipment.selectedShippingMethod.deliveryPoint
                    ) {
                        shippingUtils.hideAddressShipping(form);
                        clickCollect.hideClickCollectFinder(form, data);
                        deliveryPoints.showDeliveryPointFinder(form);
                    } else {
                        deliveryPoints.hideDeliveryPointFinder(form, data);
                    }
                });

                return;
            }

            const shipment = data.order.shipping.find(s => s.UUID === data.urlParams.shipmentUUID);

            const shippingForm = $(
                `.shipping-form input[name="shipmentUUID"][value="${shipment.UUID}"]`,
            ).closest('form');
            shippingForm.find('.pickup-in-store').data('url', shipment.pickupInstoreUrl);

            $('#pickup-in-store-store-result').hide();

            if (shipment.selectedShippingMethod) {
                if (shipment.selectedShippingMethod.storePickupEnabled) {
                    clickCollect.hideClickCollectFinder(shippingForm, data);
                    shippingUtils.hideAddressShipping(shippingForm);
                    deliveryPoints.hideDeliveryPointFinder(shippingForm, data);
                    shippingUtils.showStoreFinder(shippingForm);
                } else if (shipment.selectedShippingMethod.clickCollect) {
                    hideStoreFinder(shippingForm, data);
                    shippingUtils.hideAddressShipping(shippingForm);
                    deliveryPoints.hideDeliveryPointFinder(shippingForm, data);
                    clickCollect.showClickCollectFinder(shippingForm);
                } else if (shipment.selectedShippingMethod.deliveryPoint) {
                    hideStoreFinder(shippingForm, data);
                    clickCollect.hideClickCollectFinder(shippingForm, data);
                    shippingUtils.hideAddressShipping(shippingForm);
                    deliveryPoints.showDeliveryPointFinder(shippingForm);
                } else {
                    hideStoreFinder(shippingForm, data);
                    clickCollect.hideClickCollectFinder(shippingForm, data);
                    deliveryPoints.hideDeliveryPointFinder(shippingForm, data);
                    showAddressShipping(shippingForm);
                }
            } else {
                hideStoreFinder(shippingForm, data);
                clickCollect.hideClickCollectFinder(shippingForm, data);
                showAddressShipping(shippingForm);
            }
        });
    },
    watchForStoreSelection() {
        // change the logic for never clean the modal
        // and show the selected store in an outside div
        $('body').on('store:selected', (e, data) => {
            e.preventDefault();
            if (data.storeID) {
                const isclick = $("input[name='dwfrm_shipping_shippingAddress_shippingMethodID']:checked").data('clickcollect');
                const ispickup = $("input[name='dwfrm_shipping_shippingAddress_shippingMethodID']:checked").data('pickup');
                const pickupInStoreStoreResultSelected = $('#pickup-in-store-store-result-selected');
                if (pickupInStoreStoreResultSelected.length) {
                    pickupInStoreStoreResultSelected.remove();
                }
                const pickupInStoreResults = $('#pickup-in-store-store-result');
                const changeStoreButton = $('.store-selected-hidden-wrapper .change-store').clone();

                if (ispickup) {
                    const newLabel = $(data.storeDetailsHtml);
                    const content = $('<div class="selectedStore store-details"></div>')
                        .append(newLabel)
                        .append(`<input type="hidden" name="storeId" value="${data.storeID}" />`);
                    const checked = data.storeByDefault ? 'checked' : '';
                    if (data.authenticated) {
                        content.append(`<div class="row"><div class="col-12 form-group"><input type="checkbox" id="defaultStore" name="defaultStore" ${checked}> <label for="defaultStore" class="pt-3">${data.selectStoreText}</label></div></div>`);
                    }

                    pickupInStoreResults.empty().append(content);
                    pickupInStoreResults.append(changeStoreButton);
                    if (pickupInStoreResults.is(':hidden')) {
                        pickupInStoreResults.show();
                    }
                    pickupInStoreResults.find('.change-store').removeClass('d-none');
                } else if (isclick) {
                    const clickCollectStoreResults = $('#clickCollect-in-store-store-result');

                    const newLabel = $(data.storeDetailsHtml);
                    const content = $('<div class="selectedStore store-details"></div>')
                        .append(newLabel)
                        .append(`<input type="hidden" id="clickCollectStore" name="storeId" value="${data.storeID}" />`);

                    clickCollectStoreResults.empty().append(content);
                    clickCollectStoreResults.append(changeStoreButton);
                    if ($('#clickCollect-in-store-store-result').is(':hidden')) {
                        $('#clickCollect-in-store-store-result').show();
                    }

                    $('.clickcollect-in-store').find('.first').hide();
                    $('.clickcollect-in-store').find('.last').hide();
                }
            }
        });
    },
    initialStoreMethodSelected() {
        $(document).ready(() => {
            const isMultiship = $('#checkout-main').hasClass('multi-ship');
            if (isMultiship) {
                handleInitialMultiship();
            } else {
                handleInitialSingleship();
            }
        });
    },
    updateAddressLabelText() {
        $('body').on('shipping:updateAddressLabelText', (e, data) => {
            if (data.selectedShippingMethod) {
                const addressLabelText = data.selectedShippingMethod.storePickupEnabled
                    ? data.resources.storeAddress
                    : data.resources.shippingAddress;
                data.shippingAddressLabel.text(addressLabelText);
            }
        });
    },
    changeStore() {
        $('body').on('click', '.change-store', () => {
            const pickupInStoreStoreResultSelected = $('#pickup-in-store-store-result-selected');
            if (pickupInStoreStoreResultSelected.length) {
                pickupInStoreStoreResultSelected.remove();
            }
            const pickupSelected = $(':checked', '.shipping-method-list').data('pickup');
            const clickcollectSelected = $(':checked', '.shipping-method-list').data('clickcollect');
            const deliveryPointSelected = $(':checked', '.shipping-method-list').data('deliverypoint');
            if (pickupSelected) {
                const storePickupMode = utils.getCookie('storePickupMode');
                if (storePickupMode === 'modal') {
                    $(this).addClass('d-none');
                    $('#pickup-modal').modal('show');
                    shippingUtils.showStoreFinder($(this).closest('form'));
                } else {
                    shippingUtils.showStoreFinder($('#pickup-in-store-store-result').closest('form'));
                }
            } else if (clickcollectSelected) {
                $('#clickCollect-in-store-store-result').empty();
                $('.change-store').addClass('d-none');
                clickCollect.showClickCollectFinder($('#clickCollect-in-store-store-result').closest('form'));
            } else if (deliveryPointSelected) {
                $('#deliverypoint-in-store-store-result').empty();
                $('.change-store').addClass('d-none');
                deliveryPoints.showDeliveryPointFinder($('#deliverypoint-in-store-store-result').closest('form'));
            }
            return false;
        });
    },
    updateAddressButtonClick: instoreBase.updateAddressButtonClick,
    hideMultiShipStoreFinder: instoreBase.hideMultiShipStoreFinder,
    hideSingleShipStoreFinder: instoreBase.hideSingleShipStoreFinder,
    actionEditMultiShip: instoreBase.actionEditMultiShip,
};
